import { render, staticRenderFns } from "./ChatContent.vue?vue&type=template&id=236154dc&scoped=true"
import script from "./ChatContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChatContent.vue?vue&type=style&index=0&id=236154dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236154dc",
  null
  
)

export default component.exports